(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.spacer = this.nextElementSibling;
      this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.header && this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.onScroll();
      requestAnimationFrame(() => this.onScroll());
    }

    setHeaderHeight() {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      if (this.spacer && this.spacer.classList.contains('header-spacer')) {
        this.spacer.style.height = height + 'px';
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* Scroll 0: transparent, no shadow. After 250px: black background + box shadow */
      const scrollThreshold = 250;

      if (this.stickyType === 'none') {
        this.classList.remove('scrolled');
        if (this.header) this.header.classList.remove('scrolled-past-header');
        return;
      }
      if (this.headerIsAlwaysSticky) {
        this.classList.add('scrolled');
        if (this.header) this.header.classList.add('scrolled-past-header');
        return;
      }
      const pastThreshold = scrollTop > scrollThreshold;
      this.classList.toggle('scrolled', pastThreshold);
      if (this.header) this.header.classList.toggle('scrolled-past-header', pastThreshold);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  const link = e.target.closest('.js-smooth-scroll');
  if (!link) return;

  const hash = link.getAttribute('href');
  if (!hash || !hash.startsWith('#')) return;

  const target = document.querySelector(hash);
  if (!target) return;

  e.preventDefault();

  const header =
    document.querySelector('.header-wrapper') ||
    document.querySelector('header');

  const headerHeight = header ? header.offsetHeight : 0;

  const top =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    headerHeight;

  window.scrollTo({
    top,
    behavior: 'smooth'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-rich-text-with-btn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  const link = e.target.closest('.js-smooth-scroll');
  if (!link) return;

  const hash = link.getAttribute('href');
  if (!hash || !hash.startsWith('#')) return;

  const target = document.querySelector(hash);
  if (!target) return;

  e.preventDefault();

  const header =
    document.querySelector('.header-wrapper') ||
    document.querySelector('header');

  const headerHeight = header ? header.offsetHeight : 0;

  const top =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    headerHeight;

  window.scrollTo({
    top,
    behavior: 'smooth'
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const animatedElements = document.querySelectorAll('.animate-fade-in-left');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-left-start');
        observer.unobserve(entry.target); // animasi hanya sekali
      }
    });
  }, { threshold: 0.1 });

  animatedElements.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
